import axios from "@/axios/axios";
import moment from "moment";

export default {
  namespaced: true,
  actions: {
    requestUserDetail({ rootState }) {
      return axios
        .get("/api/account/get-profile")
        .then((response) => {
          if (response.status == 200) {
            let data = response.data;

            data.activities = JSON.parse(data.activities);
            data.industries1 = JSON.parse(data.industries1);
            data.careers = JSON.parse(data.careers);
            data.phoneNumber = data.phone
            if (!data.careers || data.careers.length == 0) {
              data.careers = [
                {
                  careerPeriodFrom: moment().format("DD/MM/YYYY"),
                  careerPeriodTo: moment().format("DD/MM/YYYY"),
                  name: "",
                  inOffice: 0,
                },
              ];
            }

            rootState.auth.user = data;
            rootState.auth.isChecked = true;

            return Promise.resolve(response);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    updateUser({ commit }, payload) {
      if (payload.birthday) payload.birthday = parseInt(payload.birthday);
      if (payload.classification)
        payload.classification = parseInt(payload.classification);
      return axios
        .post("/api/account/update-profile/individual", payload)
        .then((response) => {
          console.log(response.data);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        })
        .finally(() => {
          // 성공, 실패 관련 없이 로그인 정보 삭제
          commit('requestUserDetail')
          return Promise.resolve();
        });
    },
  },
};
